
function getShopifyAssetUrl(filename) {
  if (!filename) return '';
  var cleanName = filename.split('/').pop();
  if (window.GLOW_VIBES_ASSETS) {
    return window.GLOW_VIBES_ASSETS + cleanName;
  }
  return filename;
}
/**
 * ==========================================================================
 * GLOW VIBES - STORE FRONT & THEME ENGINE (glowvibes.store)
 * Interactive E-Commerce & Dynamic Product Variant Engine
 * ==========================================================================
 */

document.addEventListener("DOMContentLoaded", () => {
  handlePageInitOrRestore();
  initAnnouncementBar();
  initStickyHeader();
  initHeroSlider();
  initTabbedCollections();
  initFeaturedVariantPicker();
  initCardVariantPickers();
  initCartDrawer();
  initCodQuickOrder();
  initSizeCalculator();
  initRecentSalesPopup();
  initViewAllProducts();
  initCategoriesModal();
  initCategoryQuickBar();
});

// Restore cart and purge pending express checkouts when navigating back via browser history / bfcache
window.addEventListener("pageshow", () => {
  handlePageInitOrRestore();
});

/**
 * 1. Announcement Bar Ticker
 */
function initAnnouncementBar() {
  const bar = document.querySelector(".announcement-ticker");
  if (!bar) return;
  const slides = bar.querySelectorAll(".announcement-slide");
  if (slides.length <= 1) return;

  let current = 0;
  setInterval(() => {
    slides[current].style.display = "none";
    current = (current + 1) % slides.length;
    slides[current].style.display = "flex";
  }, 4000);
}

/**
 * 2. Sticky Header with Scroll Threshold
 */
function initStickyHeader() {
  const header = document.querySelector(".site-header");
  if (!header) return;

  window.addEventListener("scroll", () => {
    if (window.scrollY > 20) {
      header.classList.add("is-sticky");
    } else {
      header.classList.remove("is-sticky");
    }
  }, { passive: true });
}

/**
 * 3. Hero Banner Slider with Autoplay & Pagination
 */
function initHeroSlider() {
  const slides = document.querySelectorAll(".hero-slide");
  const dots = document.querySelectorAll(".hero-dot");
  if (!slides.length) return;

  let activeIndex = 0;
  let interval;

  function showSlide(index) {
    slides.forEach((s, i) => s.classList.toggle("active", i === index));
    dots.forEach((d, i) => d.classList.toggle("active", i === index));
    activeIndex = index;
  }

  dots.forEach(dot => {
    dot.addEventListener("click", () => {
      const idx = parseInt(dot.getAttribute("data-index") || "0", 10);
      showSlide(idx);
      resetAuto();
    });
  });

  function startAuto() {
    interval = setInterval(() => {
      let next = (activeIndex + 1) % slides.length;
      showSlide(next);
    }, 5500);
  }

  function resetAuto() {
    clearInterval(interval);
    startAuto();
  }

  startAuto();
}

/**
 * 4. Collection Tabs Filtering
 */
function initTabbedCollections() {
  const tabs = document.querySelectorAll(".tab-btn");
  const cards = document.querySelectorAll(".product-card");
  if (!tabs.length) return;

  tabs.forEach(tab => {
    tab.addEventListener("click", () => {
      tabs.forEach(t => t.classList.remove("active"));
      tab.classList.add("active");

      const filter = tab.getAttribute("data-filter");
      cards.forEach(card => {
        const cat = card.getAttribute("data-category");
        if (filter === "all" || cat === filter) {
          card.style.display = "flex";
        } else {
          card.style.display = "none";
        }
      });
    });
  });
}

function initFeaturedVariantPicker() {
  // Stored for extensible featured product variant pickers
}

/**
 * 6. Dynamic Variant Picker on Product Cards
 * Any product with variants updates card image, price and actions dynamically
 */
function initCardVariantPickers() {
  document.addEventListener("click", e => {
    const pill = e.target.closest(".card-variant-pill");
    if (!pill) return;

    const card = pill.closest(".product-card");
    if (!card) return;

    // Toggle active pill in this card
    card.querySelectorAll(".card-variant-pill").forEach(p => p.classList.remove("active"));
    pill.classList.add("active");

    const size = pill.getAttribute("data-size");
    const price = parseInt(pill.getAttribute("data-price"), 10);
    const image = pill.getAttribute("data-image");

    // Update card image if provided
    if (image) {
      const primaryImg = card.querySelector(".primary-img");
      if (primaryImg) primaryImg.src = image;
    }

    // Update card price
    const priceEl = card.querySelector(".current-price");
    if (priceEl && !isNaN(price)) {
      priceEl.textContent = `Rs. ${price.toLocaleString()}`;
    }

    // Update button attributes
    const cartBtn = card.querySelector('[data-action="add-to-cart"]');
    const codBtn = card.querySelector('[data-action="quick-cod"]');

    if (cartBtn) {
      if (size) cartBtn.setAttribute("data-variant", size);
      if (!isNaN(price)) cartBtn.setAttribute("data-price", price);
      if (image) cartBtn.setAttribute("data-image", image);
    }

    if (codBtn) {
      if (size) codBtn.setAttribute("data-variant", size);
      if (!isNaN(price)) codBtn.setAttribute("data-price", price);
      if (image) codBtn.setAttribute("data-image", image);
    }
  });
}

/**
 * 7. Shopping Bag / Cart Drawer System with Free Shipping Progress
 */
const CartState = {
  items: [],
  threshold: 2499,
  shippingFee: 199
};

const STORAGE_KEY_BAG = 'glowvibes_bag_items_v2';
const SESSION_KEY_BUYNOW = 'glowvibes_buynow_pending';

function saveBagToStorage() {
  try {
    localStorage.setItem(STORAGE_KEY_BAG, JSON.stringify(CartState.items));
  } catch(e) {}
}

function loadBagFromStorage() {
  try {
    var stored = localStorage.getItem(STORAGE_KEY_BAG);
    if (stored) {
      var parsed = JSON.parse(stored);
      if (Array.isArray(parsed)) {
        CartState.items = parsed;
        return true;
      }
    }
  } catch(e) {}
  return false;
}

// Globally reset all checkout buttons to clickable and enabled state
window.resetCheckoutButtons = function() {
  window._isCheckingOut = false;
  
  var drawerBtn = document.getElementById("CartDrawerCheckoutBtn");
  if (drawerBtn) {
    drawerBtn.style.pointerEvents = "auto";
    drawerBtn.style.opacity = "1";
    drawerBtn.disabled = false;
    if (CartState.items && CartState.items.length > 0) {
      var subtotal = CartState.items.reduce(function(sum, it) {
        return sum + (parsePrice(it.price) * (parseInt(it.qty, 10) || 1));
      }, 0);
      drawerBtn.innerHTML = `<span>⚡ Checkout with Cash on Delivery (Rs. ${subtotal.toLocaleString()})</span>`;
    } else {
      drawerBtn.innerHTML = `<span>⚡ Checkout with Cash on Delivery</span>`;
    }
  }

  var pageBtn = document.getElementById("CartPageCheckoutBtn");
  if (pageBtn) {
    pageBtn.style.pointerEvents = "auto";
    pageBtn.style.opacity = "1";
    pageBtn.disabled = false;
    pageBtn.innerHTML = `<span>⚡ Proceed to Cash on Delivery Checkout</span>`;
  }
};

// Synchronize ONLY what is currently in CartState.items to Shopify's backend AJAX cart.
// It clears any temporary/Buy-Now items from Shopify and repopulates only the persistent bag items.
function syncStorageBagToShopify(callback) {
  var done = false;
  function finish() {
    if (!done) {
      done = true;
      if (typeof callback === 'function') callback();
    }
  }
  // Safety timeout: if network hangs, proceed anyway after 1200ms
  var timer = setTimeout(finish, 1200);

  var itemsToAdd = [];
  CartState.items.forEach(function(it) {
    var numId = parseInt(it.id, 10);
    if (!isNaN(numId) && numId > 1000) {
      itemsToAdd.push({ id: numId, quantity: Math.max(1, parseInt(it.qty, 10) || 1) });
    }
  });

  try {
    fetch('/cart/clear.js', { method: 'POST' })
      .then(function() {
        if (itemsToAdd.length > 0) {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: itemsToAdd })
          });
        }
      })
      .then(function() {
        clearTimeout(timer);
        finish();
      })
      .catch(function() {
        clearTimeout(timer);
        finish();
      });
  } catch(err) {
    clearTimeout(timer);
    finish();
  }
}

function handlePageInitOrRestore() {
  window.resetCheckoutButtons();
  var hadBuyNowPending = false;
  try {
    hadBuyNowPending = sessionStorage.getItem(SESSION_KEY_BUYNOW) === 'true';
  } catch(e) {}

  if (hadBuyNowPending) {
    try {
      sessionStorage.removeItem(SESSION_KEY_BUYNOW);
    } catch(e) {}
    loadBagFromStorage();
    syncStorageBagToShopify();
  } else {
    loadBagFromStorage();
  }

  // Clear bag if order was completed on checkout (thank you page)
  if (window.location.pathname.indexOf('/thank_you') !== -1 || window.location.pathname.indexOf('order-received') !== -1) {
    CartState.items = [];
    saveBagToStorage();
    try { fetch('/cart/clear.js', { method: 'POST' }); } catch(e) {}
  }

  renderCart();
  updateHeaderCartCount();
  if (typeof renderCartPage === 'function') {
    renderCartPage();
  }
}

// Robust helper to parse Pakistani Rupee prices (e.g. "Rs. 1,699.00" -> 1699, "169900" -> 1699)
function parsePrice(val) {
  if (typeof val === 'number') {
    if (val > 30000 && val % 100 === 0) return Math.round(val / 100);
    return Math.round(val);
  }
  if (!val) return 0;
  var s = String(val).replace(/Rs/gi, '').replace(/PKR/gi, '').replace(/,/g, '').trim();
  s = s.replace(/^[.\s]+/, '');
  var hasExplicitDecimal = s.indexOf('.') !== -1;
  var num = parseFloat(s);
  if (isNaN(num)) return 0;
  if (!hasExplicitDecimal && num > 30000 && num % 100 === 0) {
    return Math.round(num / 100);
  }
  return Math.round(num);
}

function initCartDrawer() {
  const drawer = document.getElementById("CartDrawer");
  const overlay = document.getElementById("CartDrawerOverlay");
  const openBtns = document.querySelectorAll('[data-action="open-cart"]');
  const closeBtns = document.querySelectorAll('[data-action="close-cart"]');

  if (!drawer || !overlay) return;

  function openCart() {
    loadBagFromStorage();
    drawer.classList.add("active");
    overlay.classList.add("active");
    renderCart();
    updateHeaderCartCount();
  }

  function closeCart() {
    drawer.classList.remove("active");
    overlay.classList.remove("active");
  }

  openBtns.forEach(btn => btn.addEventListener("click", e => {
    e.preventDefault();
    openCart();
  }));

  closeBtns.forEach(btn => btn.addEventListener("click", closeCart));
  overlay.addEventListener("click", closeCart);

  // Close drawer when clicking [data-action="close-cart"] inside drawer content
  drawer.addEventListener("click", e => {
    const btn = e.target.closest('[data-action="close-cart"]');
    if (btn) {
      e.preventDefault();
      closeCart();
    }
  });

  // Global Add to Cart listener
  document.addEventListener("click", e => {
    const addBtn = e.target.closest('[data-action="add-to-cart"]');
    if (!addBtn) return;
    e.preventDefault();

    loadBagFromStorage();

    const id = addBtn.getAttribute("data-variant-id") || addBtn.getAttribute("data-id") || ("item-" + Date.now());
    const title = addBtn.getAttribute("data-title") || "Glow Vibes Beauty Item";
    const rawPrice = addBtn.getAttribute("data-price") || "1650";
    const price = parsePrice(rawPrice) || 1650;
    const image = addBtn.getAttribute("data-img") || addBtn.getAttribute("data-image") || "";
    const variant = addBtn.getAttribute("data-variant") || "Standard";

    const existing = CartState.items.find(item => String(item.id) === String(id) && item.variant === variant);
    if (existing) {
      existing.qty += 1;
    } else {
      CartState.items.push({ id, title, price, qty: 1, image, variant });
    }
    saveBagToStorage();

    // Sync to Shopify cart backend
    if (id && !isNaN(parseInt(id))) {
      try {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(id), quantity: 1 })
        });
      } catch(err) {}
    }

    openCart();
    updateHeaderCartCount();
  });

  const checkoutBtn = document.getElementById("CartDrawerCheckoutBtn");
  if (checkoutBtn) {
    checkoutBtn.addEventListener("click", function(e) {
      e.preventDefault();
      window.goToCheckout();
    });
  }

  loadBagFromStorage();
  renderCart();
  updateHeaderCartCount();
}

window.goToCheckout = function() {
  loadBagFromStorage();
  if (!CartState.items || CartState.items.length === 0) {
    alert("Your shopping bag is empty! Please add a product first.");
    return;
  }

  // Mutex lock to prevent duplicate parallel executions
  if (window._isCheckingOut) return;
  window._isCheckingOut = true;

  var drawerBtn = document.getElementById("CartDrawerCheckoutBtn");
  if (drawerBtn) {
    drawerBtn.innerHTML = `<span>⏳ Loading Checkout...</span>`;
    drawerBtn.style.opacity = "0.7";
    drawerBtn.style.pointerEvents = "none";
  }

  var pageBtn = document.getElementById("CartPageCheckoutBtn");
  if (pageBtn) {
    pageBtn.innerHTML = `<span>⏳ Loading Checkout...</span>`;
    pageBtn.style.opacity = "0.7";
    pageBtn.style.pointerEvents = "none";
  }

  // Ensure latest items are saved to localStorage so back button keeps them
  saveBagToStorage();
  try { sessionStorage.removeItem(SESSION_KEY_BUYNOW); } catch(e) {}

  // Fallback watchdog: If navigation does not happen within 3 seconds, reset buttons
  setTimeout(function() {
    window.resetCheckoutButtons();
  }, 3000);

  // Sync ONLY the persistent bag items to Shopify's backend cart and navigate cleanly
  syncStorageBagToShopify(function() {
    window.location.href = '/checkout';
  });
};

function renderCart() {
  const container = document.getElementById("CartDrawerItems");
  const subtotalEl = document.getElementById("CartSubtotal");
  const progressFill = document.getElementById("ShippingProgressFill");
  const progressText = document.getElementById("ShippingProgressText");
  const checkoutBtn = document.getElementById("CartDrawerCheckoutBtn");

  if (!container) return;

  if (CartState.items.length === 0) {
    container.innerHTML = `
      <div style="text-align: center; padding: 60px 20px;">
        <div style="font-size: 42px; margin-bottom: 12px;">🛍️</div>
        <h4 style="font-size: 18px; margin-bottom: 6px;">Your bag is empty</h4>
        <p style="font-size: 14px; color: var(--color-text-muted); margin-bottom: 20px;">Explore our luxury comfort bras, bundles & shapewear to add your favorites.</p>
        <button class="btn btn-primary" data-action="close-cart">Explore Undergarments</button>
      </div>
    `;
    if (subtotalEl) subtotalEl.textContent = "Rs. 0";
    if (progressFill) progressFill.style.width = "0%";
    if (progressText) progressText.innerHTML = `Add Rs. ${CartState.threshold.toLocaleString()} more for <strong>FREE Nationwide Delivery</strong>!`;
    window.resetCheckoutButtons();
    return;
  }

  let subtotal = 0;
  let html = "";

  CartState.items.forEach((item, idx) => {
    const itemPrice = parsePrice(item.price);
    const itemQty = parseInt(item.qty, 10) || 1;
    const itemTotal = itemPrice * itemQty;
    subtotal += itemTotal;

    html += `
      <div class="cart-item">
        <img src="${item.image}" alt="${item.title}">
        <div class="cart-item-info">
          <div style="display: flex; justify-content: space-between; align-items: flex-start; gap: 8px;">
            <h4 class="cart-item-title" style="margin-bottom: 2px;">${item.title}</h4>
            <button type="button" class="cart-item-remove-btn" onclick="removeCartItem(${idx})" title="Remove item from bag" aria-label="Remove item">
              <span class="remove-icon">🗑️</span> <span class="remove-text">Remove</span>
            </button>
          </div>
          <p class="cart-item-variant">${item.variant}</p>
          <div class="cart-item-row">
            <div class="qty-stepper">
              <button class="qty-btn" onclick="updateItemQty(${idx}, -1)">-</button>
              <span class="qty-val">${itemQty}</span>
              <button class="qty-btn" onclick="updateItemQty(${idx}, 1)">+</button>
            </div>
            <div class="cart-item-price">Rs. ${itemTotal.toLocaleString()}</div>
          </div>
        </div>
      </div>
    `;
  });

  container.innerHTML = html;
  if (subtotalEl) subtotalEl.textContent = `Rs. ${subtotal.toLocaleString()}`;

  // Always reset checkout buttons to active and enabled state
  window.resetCheckoutButtons();

  // Progress Bar for Free Shipping
  if (progressFill && progressText) {
    if (subtotal >= CartState.threshold) {
      progressFill.style.width = "100%";
      progressText.innerHTML = `🎉 <strong>Congratulations!</strong> You have unlocked FREE Nationwide Delivery!`;
    } else {
      const remaining = CartState.threshold - subtotal;
      const pct = Math.min(100, Math.round((subtotal / CartState.threshold) * 100));
      progressFill.style.width = `${pct}%`;
      progressText.innerHTML = `Add <strong>Rs. ${remaining.toLocaleString()}</strong> more for <strong>FREE Delivery</strong>!`;
    }
  }

  updateHeaderCartCount();
}

window.updateItemQty = function(idx, change) {
  if (!CartState.items[idx]) return;
  var item = CartState.items[idx];
  item.qty += change;
  if (item.qty <= 0) {
    CartState.items.splice(idx, 1);
  }
  saveBagToStorage();
  renderCart();
  if (typeof renderCartPage === 'function') {
    renderCartPage();
  }
  window.resetCheckoutButtons();
};

window.removeCartItem = function(idx) {
  if (idx >= 0 && idx < CartState.items.length) {
    CartState.items.splice(idx, 1);
    saveBagToStorage();
    renderCart();
    if (typeof renderCartPage === 'function') {
      renderCartPage();
    }
    window.resetCheckoutButtons();
  }
};

function updateHeaderCartCount() {
  const totalCount = CartState.items.reduce((sum, item) => sum + item.qty, 0);
  document.querySelectorAll(".cart-count-badge").forEach(badge => {
    badge.textContent = totalCount;
  });
}

/**
 * 8. 1-Click Cash on Delivery (COD) Quick Order Modal
 */
function initCodQuickOrder() {
  const modal = document.getElementById("CodOrderModal");
  const closeBtn = document.getElementById("CodModalClose");
  const form = document.getElementById("CodOrderForm");

  if (!modal) return;

  document.addEventListener("click", e => {
    const codBtn = e.target.closest('[data-action="quick-cod"]');
    if (!codBtn) return;
    // Cart drawer checkout button navigates directly to /checkout; do not open popup
    if (codBtn.id === "CartDrawerCheckoutBtn" || codBtn.closest(".cart-drawer")) {
      return;
    }
    e.preventDefault();

    let title, price, image, variant, qty;

    // Check if clicked from Cart Drawer
    if (codBtn.id === "CartDrawerCheckoutBtn" || codBtn.closest(".cart-drawer")) {
      if (!CartState.items || CartState.items.length === 0) {
        alert("Your shopping bag is empty! Please add a product first.");
        return;
      }
      const first = CartState.items[0];
      const totalQty = CartState.items.reduce((sum, it) => sum + it.qty, 0);
      const subtotal = CartState.items.reduce((sum, it) => sum + (parsePrice(it.price) * it.qty), 0);

      title = CartState.items.length === 1 ? first.title : `${first.title} (+ ${CartState.items.length - 1} more items)`;
      price = subtotal;
      image = first.image;
      variant = CartState.items.length === 1 ? first.variant : `${totalQty} Total Items`;
      qty = 1;
    } else {
      title = codBtn.getAttribute("data-title") || "Glow Vibes Beauty Item";
      price = parsePrice(codBtn.getAttribute("data-price") || "1650");
      image = codBtn.getAttribute("data-image") || codBtn.getAttribute("data-img") || "";
      variant = codBtn.getAttribute("data-variant") || "Standard Size";
      qty = parseInt(codBtn.getAttribute("data-qty") || "1", 10) || 1;
    }

    const isCartCheckout = (codBtn.id === "CartDrawerCheckoutBtn" || codBtn.closest(".cart-drawer"));
    const qtyFormGroup = document.getElementById("CodQtyFormGroup");
    if (qtyFormGroup) {
      qtyFormGroup.style.display = isCartCheckout ? "none" : "flex";
    }

    const previewImg = document.getElementById("CodPreviewImg");
    const previewTitle = document.getElementById("CodPreviewTitle");
    const previewPrice = document.getElementById("CodPreviewPrice");
    const previewVariant = document.getElementById("CodPreviewVariant");
    const priceInput = document.getElementById("CodProductPrice");
    const qtyInput = document.getElementById("CodQty");

    if (previewImg) previewImg.src = image;
    if (previewTitle) previewTitle.textContent = title;
    if (previewPrice) previewPrice.textContent = `Rs. ${price.toLocaleString()}`;
    if (previewVariant) previewVariant.textContent = variant;
    if (priceInput) priceInput.value = price;
    if (qtyInput) qtyInput.value = qty;

    updateCodSummary(price, qty);
    modal.classList.add("active");
  });

  if (closeBtn) closeBtn.addEventListener("click", () => modal.classList.remove("active"));
  modal.addEventListener("click", e => {
    if (e.target === modal) modal.classList.remove("active");
  });

  const qtyInput = document.getElementById("CodQty");
  if (qtyInput) {
    qtyInput.addEventListener("change", () => {
      const price = parsePrice(document.getElementById("CodProductPrice").value) || 0;
      const qty = Math.max(1, parseInt(qtyInput.value || "1", 10));
      updateCodSummary(price, qty);
    });
  }

  if (form) {
    form.addEventListener("submit", e => {
      e.preventDefault();
      const submitBtn = document.getElementById("CodSubmitBtn");
      const name = document.getElementById("CodCustomerName").value.trim();
      const phone = document.getElementById("CodCustomerPhone").value.trim();
      const city = document.getElementById("CodCustomerCity").value.trim();
      const address = document.getElementById("CodCustomerAddress").value.trim();
      const orderedTitle = document.getElementById("CodPreviewTitle") ? document.getElementById("CodPreviewTitle").textContent : "Glow Vibes Order";
      const orderedTotal = document.getElementById("CodSummaryTotal") ? document.getElementById("CodSummaryTotal").textContent : "";

      if (!name || !phone || !city || !address) {
        alert("Please fill out all required delivery fields.");
        return;
      }

      submitBtn.disabled = true;
      submitBtn.innerHTML = `<span>⏳ Processing Order...</span>`;

      setTimeout(() => {
        const orderId = "GV-" + Math.floor(100000 + Math.random() * 900000);
        modal.classList.remove("active");
        submitBtn.disabled = false;
        submitBtn.innerHTML = `<span>⚡ Confirm Cash on Delivery Order</span>`;

        alert(`🎉 ORDER CONFIRMED! (Order #${orderId})

Thank you, ${name}!
Your Cash on Delivery order at Glow Vibes has been successfully registered.

📦 Order: ${orderedTitle}
💰 Total Amount: ${orderedTotal}
📍 Delivery to: ${address}, ${city}
📞 Contact: ${phone}
🚚 Dispatch: Within 24 Hours with 100% Discreet & Sealed Packaging.
💵 Payment: Hand over cash to courier upon arrival.`);

        // Clear bag if checkout originated from shopping bag
        if (CartState && CartState.items && CartState.items.length > 0) {
          CartState.items = [];
          saveBagToStorage();
          renderCart();
          updateHeaderCartCount();
        }

        form.reset();
      }, 1200);
    });
  }
}

function updateCodSummary(unitPrice, qty) {
  const subtotal = unitPrice * qty;
  const shipping = subtotal >= CartState.threshold ? 0 : CartState.shippingFee;
  const total = subtotal + shipping;

  const subtotalEl = document.getElementById("CodSummarySubtotal");
  const shippingEl = document.getElementById("CodSummaryShipping");
  const totalEl = document.getElementById("CodSummaryTotal");

  if (subtotalEl) subtotalEl.textContent = `Rs. ${subtotal.toLocaleString()}`;
  if (shippingEl) shippingEl.textContent = shipping === 0 ? "FREE" : `Rs. ${shipping}`;
  if (totalEl) totalEl.textContent = `Rs. ${total.toLocaleString()}`;
}

/**
 * 9. "View All Products" Button Action
 */
function initViewAllProducts() {
  const btn = document.getElementById("ViewAllProductsBtn");
  const hiddenCards = document.querySelectorAll(".product-card.hidden-catalog-item");

  if (!btn) return;

  btn.addEventListener("click", e => {
    e.preventDefault();
    if (hiddenCards.length) {
      hiddenCards.forEach(card => {
        card.classList.remove("hidden-catalog-item");
        card.style.display = "flex";
      });
      btn.innerHTML = "<span>✨ All Products Displayed</span>";
      btn.style.opacity = "0.7";
      btn.style.pointerEvents = "none";
    }
  });
}

/**
 * 10. Bra & Undergarment Size Calculator Modal
 */
function initSizeCalculator() {
  const modal = document.getElementById("SizeGuideModal");
  const openBtns = document.querySelectorAll('[data-action="open-size-guide"]');
  const closeBtn = document.getElementById("SizeGuideClose");
  const calcBtn = document.getElementById("CalculateSizeBtn");

  if (!modal) return;

  openBtns.forEach(btn => btn.addEventListener("click", e => {
    e.preventDefault();
    modal.classList.add("active");
  }));

  if (closeBtn) closeBtn.addEventListener("click", () => modal.classList.remove("active"));
  modal.addEventListener("click", e => {
    if (e.target === modal) modal.classList.remove("active");
  });

  if (calcBtn) {
    calcBtn.addEventListener("click", () => {
      const underbust = parseFloat(document.getElementById("UnderbustInput").value || "0");
      const bust = parseFloat(document.getElementById("BustInput").value || "0");

      if (!underbust || !bust || bust <= underbust) {
        alert("Please enter valid measurements (Bust size should be larger than Underbust).");
        return;
      }

      let band = Math.round(underbust);
      if (band % 2 !== 0) band += 1;

      const diff = bust - underbust;
      let cup = "A";
      if (diff >= 0.5 && diff < 1.5) cup = "A";
      else if (diff >= 1.5 && diff < 2.5) cup = "B";
      else if (diff >= 2.5 && diff < 3.5) cup = "C";
      else if (diff >= 3.5 && diff < 4.5) cup = "D";
      else if (diff >= 4.5 && diff < 5.5) cup = "DD";
      else if (diff >= 5.5) cup = "E";

      const primarySize = `${band}${cup}`;
      const sisterSize = `${band + 2}${cup === "C" ? "B" : cup === "B" ? "A" : "C"}`;

      const resBox = document.getElementById("CalculatorResultBox");
      if (resBox) {
        resBox.style.display = "block";
        document.getElementById("CalculatedPrimarySize").textContent = primarySize;
        document.getElementById("CalculatedSisterSize").textContent = sisterSize;
      }
    });
  }
}

/**
 * 11. Recent Sales Social Proof Notification Toast
 */
function initRecentSalesPopup() {
  const toast = document.getElementById("RecentSalesToast");
  if (!toast) return;

  const mockPurchases = [
    {
      name: "Fatima A.",
      city: "Lahore",
      product: "BUY 1 GET 2 FREE Breathable Cool Liftup Air Bra (3-Pack)",
      time: "2 mins ago",
      img: "hero-product-2.webp"
    },
    {
      name: "Ayesha N.",
      city: "Karachi",
      product: "2025 Anti-Sagging Front-Open Cooling Cotton Bra",
      time: "4 mins ago",
      img: "hero-product-1.webp"
    },
    {
      name: "Sana K.",
      city: "Islamabad",
      product: "Seamless Comfort Wire-Free Everyday Bra",
      time: "6 mins ago",
      img: "seamless-bra.jpg"
    },
    {
      name: "Zainab M.",
      city: "Rawalpindi",
      product: "High-Waist Instant Tummy Sculpting Shaper (Champagne)",
      time: "9 mins ago",
      img: "waist-shaper.jpg"
    },
    {
      name: "Hina R.",
      city: "Faisalabad",
      product: "Cotton Cross Bra for Women (4-Pack Daily Comfort)",
      time: "12 mins ago",
      img: "hero-product-1.webp"
    }
  ];

  let index = 0;

  function showNextToast() {
    const item = mockPurchases[index];
    index = (index + 1) % mockPurchases.length;

    const imgEl = document.getElementById("ToastImg");
    const nameEl = document.getElementById("ToastName");
    const prodEl = document.getElementById("ToastProduct");
    const timeEl = document.getElementById("ToastTime");

    if (imgEl) imgEl.src = getShopifyAssetUrl(item.img);
    if (nameEl) nameEl.textContent = `${item.name} (${item.city})`;
    if (prodEl) prodEl.textContent = item.product;
    if (timeEl) timeEl.textContent = `Purchased via COD • ${item.time}`;

    toast.classList.add("show");

    setTimeout(() => {
      toast.classList.remove("show");
    }, 4500);
  }

  setTimeout(() => {
    showNextToast();
    setInterval(showNextToast, 14000);
  }, 4000);
}

/**
 * 12. Categories Mega Modal & Trigger Handler
 */
function initCategoriesModal() {
  const modal = document.getElementById('CategoriesModal');
  const navBtn = document.getElementById('CategoriesNavBtn');
  const openTriggers = document.querySelectorAll('[data-action="open-categories-modal"]');
  const closeTriggers = document.querySelectorAll('[data-action="close-categories-modal"]');

  if (!modal) return;

  function openModal() {
    modal.classList.add('active');
    if (navBtn) navBtn.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    modal.classList.remove('active');
    if (navBtn) navBtn.classList.remove('open');
    document.body.style.overflow = '';
  }

  if (navBtn) {
    navBtn.addEventListener('click', (e) => {
      e.preventDefault();
      if (modal.classList.contains('active')) {
        closeModal();
      } else {
        openModal();
      }
    });
  }

  openTriggers.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      openModal();
    });
  });

  // Delegated listener so any dynamically loaded or mobile triggers always open modal
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-action="open-categories-modal"]');
    if (trigger) {
      e.preventDefault();
      openModal();
    }
  });

  closeTriggers.forEach(btn => {
    btn.addEventListener('click', () => {
      closeModal();
    });
  });

  modal.addEventListener('click', (e) => {
    if (e.target === modal) {
      closeModal();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.classList.contains('active')) {
      closeModal();
    }
  });
}

/**
 * 13. Category Quick-Nav Sticky Bar Active Scroll Tracking
 */
function initCategoryQuickBar() {
  const bar = document.getElementById('CategoryQuickBar');
  if (!bar) return;

  const chips = bar.querySelectorAll('.quick-cat-chip[href^="#"]');
  const sections = Array.from(chips).map(chip => {
    const id = chip.getAttribute('href').substring(1);
    return document.getElementById(id);
  }).filter(Boolean);

  window.addEventListener('scroll', () => {
    let currentId = '';
    const scrollPos = window.scrollY + 180;

    sections.forEach(sec => {
      if (sec.offsetTop <= scrollPos) {
        currentId = sec.id;
      }
    });

    if (currentId) {
      chips.forEach(chip => {
        if (chip.getAttribute('href') === '#' + currentId) {
          chip.classList.add('active');
        } else if (!chip.classList.contains('highlight')) {
          chip.classList.remove('active');
        }
      });
    }
  }, { passive: true });
}

// Expose GlowVibes global helper for product pages and custom buttons
window.GlowVibes = {
  addToBag: function(variantId, qty, title, priceStr, imgUrl, variantStr) {
    qty = parseInt(qty, 10) || 1;
    var numPrice = parsePrice(priceStr) || 1699;
    var variant = variantStr || "Standard";
    
    loadBagFromStorage();

    // 1. Update local CartState
    var existing = CartState.items.find(function(item) { 
      return String(item.id) === String(variantId) && item.variant === variant; 
    });
    if (existing) {
      existing.qty += qty;
    } else {
      CartState.items.push({
        id: variantId,
        title: title || "Glow Vibes Beauty Item",
        price: numPrice,
        qty: qty,
        image: imgUrl || "",
        variant: variant
      });
    }
    saveBagToStorage();

    // 2. Sync with real Shopify AJAX Cart if available
    if (variantId && !isNaN(parseInt(variantId))) {
      try {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId), quantity: qty })
        });
      } catch(e) {}
    }

    // 3. Open Drawer
    var drawer = document.getElementById("CartDrawer");
    var overlay = document.getElementById("CartDrawerOverlay");
    if (drawer && overlay) {
      drawer.classList.add("active");
      overlay.classList.add("active");
      renderCart();
      updateHeaderCartCount();
    }
  },

  openCodModal: function(title, priceStr, imgUrl, variantId, variantStr) {
    var modal = document.getElementById("CodOrderModal");
    if (!modal) return;
    var numPrice = parsePrice(priceStr) || 1699;
    var variant = variantStr || 'Standard / Selected Option';

    var previewImg = document.getElementById("CodPreviewImg");
    var previewTitle = document.getElementById("CodPreviewTitle");
    var previewPrice = document.getElementById("CodPreviewPrice");
    var previewVariant = document.getElementById("CodPreviewVariant");
    var productPriceInput = document.getElementById("CodProductPrice");
    var qtyInput = document.getElementById("CodQty");

    if (previewImg && imgUrl) previewImg.src = imgUrl;
    if (previewTitle && title) previewTitle.textContent = title;
    if (previewPrice) previewPrice.textContent = 'Rs. ' + numPrice.toLocaleString();
    if (previewVariant) previewVariant.textContent = variant;
    if (productPriceInput) productPriceInput.value = numPrice;
    if (qtyInput) qtyInput.value = 1;

    updateCodSummary(numPrice, 1);
    modal.classList.add("active");
  },

  buyNow: function(variantId, qty, title, priceStr, imgUrl, variantStr) {
    qty = parseInt(qty, 10) || 1;
    var numPrice = parsePrice(priceStr) || 1699;
    var variant = variantStr || "Standard";

    // Mark in sessionStorage that a Buy-It-Now express checkout is pending
    // This allows us to purge Shopify backend temporary cart if user hits Back
    try {
      sessionStorage.setItem(SESSION_KEY_BUYNOW, 'true');
    } catch(e) {}

    // DO NOT touch CartState.items or localStorage! The customer's bag remains 100% intact!
    var done = false;
    function proceedToCheckout() {
      if (!done) {
        done = true;
        window.location.href = '/checkout';
      }
    }
    var timer = setTimeout(proceedToCheckout, 1500);

    try {
      fetch('/cart/clear.js', { method: 'POST' })
        .then(function() {
          if (variantId && !isNaN(parseInt(variantId))) {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: parseInt(variantId), quantity: qty })
            });
          }
        })
        .then(function(res) {
          clearTimeout(timer);
          proceedToCheckout();
        })
        .catch(function() {
          clearTimeout(timer);
          proceedToCheckout();
        });
    } catch(e) {
      clearTimeout(timer);
      proceedToCheckout();
    }
  }
};
